import type { ComponentOverrides } from 'theme/theme.types';

export const LINEAR_PROGRESS_RADIUS_PX = 999;

export const MuiLinearProgress: ComponentOverrides['MuiLinearProgress'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: `${LINEAR_PROGRESS_RADIUS_PX}px`,
      backgroundColor: theme.palette.grey[200],
      '@media (forced-colors: active)': {
        forcedColorAdjust: 'none',
        backgroundColor: 'Canvas',
        outline: '1px solid CanvasText',
      },
    }),
    bar1: {
      transition: 'none',
      '@media (forced-colors: active)': {
        forcedColorAdjust: 'none',
        backgroundColor: 'CanvasText',
      },
    },
  },
};
